import { render } from "./userLicenceForm.vue?vue&type=template&id=7577bdf5&ts=true"
import script from "./userLicenceForm.vue?vue&type=script&lang=ts"
export * from "./userLicenceForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__